import { render, staticRenderFns } from "./puDetailReportList.vue?vue&type=template&id=44e9321d"
import script from "./puDetailReportList.vue?vue&type=script&lang=js"
export * from "./puDetailReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports